import Api from 'api'

const config = {
  baseURL: '/api/app/v1/faq',
}
const api = new Api(config)

api.fetchCategories = ({ ...rest } = {}) => api.get(`/categories`, { ...rest })
api.fetchCategoryBySlug = ({ slug, ...rest } = {}) => api.get(`/categories/${slug}`, { ...rest })
api.fetchCategoriesTree = ({ ...rest } = {}) => api.get(`/categories/tree`, { ...rest })
api.fetchArticleBySlug = ({ slug, ...rest } = {}) => api.get(`/articles/${slug}`, { ...rest })
api.fetchArticleRatingVote = ({ slug } = {}) => api.get(`/articles/${slug}/rating-vote`)
api.postArticleRatingVote = ({ slug, ...rest } = {}) =>
  api.post(`/articles/${slug}/rating-vote`, { ...rest })
api.putArticleRatingVote = ({ slug, ...rest } = {}) =>
  api.put(`/articles/${slug}/rating-vote`, { ...rest })
api.deleteArticleRatingVote = ({ slug } = {}) => api.delete(`/articles/${slug}/rating-vote`)

export default api
